<template>
  <v-container class="mx-1" fluid v-if="languageData.section">
        <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong>{{ snackbar.title }}</strong>
          </div>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="e1" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header class="autoheight">
              <div class="py-5 pl-5 mr-3" v-if="layout !== 'projectForm' && layout !== 'offerForm' && layout !== 'editModal'">
                <BackButton />
              </div>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>
              
              <v-stepper-step @click="setStep(1)" :complete="e1 > 1" step="1">{{ languageData.section.companyInfo }}</v-stepper-step>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

              <v-stepper-step :ref="layout === 'edit' ? null : 'lastStep'" @click="setStep(2)" :complete="e1 > 2" step="2">{{ languageData.section.address }}</v-stepper-step>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

              <v-stepper-step v-if="layout !== 'editModal'" @click="setStep(3)" :complete="e1 > 3" step="3">{{ languageData.section.peopleList }}</v-stepper-step>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

              <v-stepper-step v-if="layout === 'edit'" @click="setStep(4)" :complete="e1 > 4" step="4">{{ languageData.section.notes }}</v-stepper-step>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

              <v-stepper-step v-if="layout === 'edit'" @click="setStep(5)" :complete="e1 > 5" step="5">{{ languageData.section.documents }}</v-stepper-step>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

              <v-stepper-step v-if="layout === 'edit'" @click="setStep(6)" :complete="e1 > 6" step="6">{{ languageData.section.plannedContacts }}</v-stepper-step>
              <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

              <v-stepper-step :ref="layout === 'edit' ? 'lastStep' : null" v-if="layout === 'edit'" @click="setStep(7)" :complete="e1 > 7" step="7">{{ languageData.section.financialSummary }}</v-stepper-step>
            </v-stepper-header>
          </v-card>
          <v-card :class="$vuetify.breakpoint.smAndUp ? 'px-10' : null">
            <v-stepper-items >
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-form ref="formS" v-model="validS" @hook:mounted="handleForm('formS')">
                        <p class="text-h5 mb-7">{{ languageData.section.companyInfo }}</p>
                        <div :class="{'d-flex': $vuetify.breakpoint.mdAndUp}">
                          <v-text-field
                              height="55px"
                              outlined
                              :placeholder="languageData.labels.customerNumber"
                              :label="languageData.labels.customerNumber"
                              v-model="data.customerNumber"
                              :readonly="isCustomerNumberAutoGenerated"
                          ></v-text-field>
                          <v-checkbox
                              v-model="isCustomerNumberAutoGenerated"
                              class="ml-0 ml-md-5"
                              :label="languageData.labels.autoGenerateCustomerNumber"
                              @change="handleCustomerNumberGeneration"
                          ></v-checkbox>
                        </div>
                        <div :class="{'d-flex': $vuetify.breakpoint.mdAndUp}">
                          <v-select
                              :label="languageData.labels.title || 'Title'"
                              :class="{'mr-4': $vuetify.breakpoint.mdAndUp}"
                              name="title"
                              height="55px"
                              outlined
                              :items="[
                                { text: 'Herr', value: 1 },
                                { text: 'Frau', value: 2 },
                                { text: 'Firma', value: 3 },
                                { text: 'Familie', value: 4 },
                                { text: 'Herrn und Frau', value: 5 }
                              ]"
                              item-text="text"
                              item-value="value"
                              v-model="data.title"></v-select>
                          <v-text-field
                              :label="languageData.labels.company_name"
                              name="name"
                              height="55px"
                              outlined
                              :placeholder="languageData.labels.company_name"
                              v-model="data.name"></v-text-field>
                        </div>
                        <div :class="{'d-flex': $vuetify.breakpoint.mdAndUp}">
                          <v-text-field
                              :class="{'mr-4': $vuetify.breakpoint.mdAndUp}"
                              height="55px"
                              outlined
                              :placeholder="languageData.labels.www"
                              :label="languageData.labels.www"
                              v-model="data.www"></v-text-field>
                          <v-text-field
                              height="55px"
                              outlined
                              :placeholder="languageData.labels.email"
                              :label="languageData.labels.email"
                              v-model="data.email"></v-text-field>
                        </div>
                        <div :class="{'d-flex': $vuetify.breakpoint.mdAndUp}">
                          <v-text-field
                              :class="{'mr-4': $vuetify.breakpoint.mdAndUp}"
                              height="55px"
                              outlined
                              :placeholder="languageData.labels.phone_number"
                              :label="languageData.labels.phone_number"
                              v-model="data.phone"></v-text-field>
                          <v-text-field
                              :class="{'mr-4': $vuetify.breakpoint.mdAndUp}"
                              height="55px"
                              outlined
                              :placeholder="languageData.labels.phone_number_second"
                              :label="languageData.labels.phone_number_second"
                              v-model="data.phoneSecond"></v-text-field>
                          <v-text-field
                              height="55px"
                              outlined
                              :placeholder="languageData.labels.mobile_phone"
                              :label="languageData.labels.mobile_phone"
                              v-model="data.mobilePhone"></v-text-field>
                        </div>
                        <div :class="{'d-flex': $vuetify.breakpoint.mdAndUp}">
                          <v-text-field
                              :class="{'mr-4': $vuetify.breakpoint.mdAndUp}"
                              height="55px"
                              outlined
                              :placeholder="languageData.labels.tax_id"
                              :label="languageData.labels.tax_id"
                              v-model="data.taxId"
                              ></v-text-field>
                          <v-text-field
                              height="55px"
                              outlined
                              :placeholder="languageData.labels.vat_number"
                              :label="languageData.labels.vat_number"
                              v-model="data.vatNumber"
                              ></v-text-field>
                        </div>
                        <div :class="{'d-flex': $vuetify.breakpoint.mdAndUp}">
                          <v-text-field
                              height="55px"
                              :class="{'mr-4': $vuetify.breakpoint.mdAndUp}"
                              outlined
                              :placeholder="languageData.labels.reference_of_buyer"
                              :label="languageData.labels.reference_of_buyer"
                              v-model="data.referenceOfBuyer"
                          ></v-text-field>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                  class="guides-question-mark mt-4"
                                  v-bind="attrs"
                                  v-on="on"
                              >?</span>
                            </template>
                            <span>{{ languageData.messages.vat_number_information }}</span>
                          </v-tooltip>
                        </div>
                        <div class="d-flex justify-end">
                          <v-btn
                              class="button-shadow"
                              height="55px"
                              color="primary"
                              outlined
                              @click="setStep(2)">
                            {{ languageData.next }}
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-form ref="formT" v-model="validT" @hook:mounted="handleForm('formT')">
                        <p class="text-h5 mb-7">{{ languageData.section.address}}</p>
                        <v-row>
                          <v-col
                              :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.street"
                                :label="languageData.labels.street"
                                v-model="data.address.street"></v-text-field>
                          </v-col>
                          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.building_number"
                                :label="languageData.labels.building_number"
                                v-model="data.address.building_number"></v-text-field>
                          </v-col>
                          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.flat_number"
                                :label="languageData.labels.flat_number"
                                v-model="data.address.flat_number"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.postal_code"
                                :label="languageData.labels.postal_code"
                                v-model="data.address.postal_code"></v-text-field>
                          </v-col>
                          <v-col
                            :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.city"
                                :label="languageData.labels.city"
                                v-model="data.address.city"></v-text-field>
                          </v-col>
                          <v-col
                            v-if="countries.length > 0"
                            :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-select
                              v-model="data.address.country_id"
                              :items="countries"
                              :label="languageData.labels.country"
                              outlined
                              item-value="id"
                              item-text="name"
                              height="55px"
                          >
                            <template slot='selection' slot-scope='{ item }'>
                              {{ item.name }}
                            </template>
                            <template slot='item' slot-scope='{ item }'>
                              {{ item.name }}
                            </template>
                          </v-select>
                          </v-col>
                        </v-row>
                        <v-checkbox
                            v-model="data.invoice_is"
                            :label="languageData.labels.question_invoice_address"
                            color="primary"
                            hide-details
                        ></v-checkbox>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" v-if="!data.invoice_is">
                      <v-form ref="formU" v-model="validU" @hook:mounted="handleForm('formU')">
                        <p class="text-h5">{{ languageData.section.invoiceAddress }}</p>
                        <v-row>
                          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.street"
                                :label="languageData.labels.street"
                                :rules="rules['address_invoice.street']"
                                v-model="data.address_invoice.street"></v-text-field>
                          </v-col>
                          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.building_number"
                                :label="languageData.labels.building_number"
                                v-model="data.address_invoice.building_number"></v-text-field>
                          </v-col>
                          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.flat_number"
                                :label="languageData.labels.flat_number"
                                v-model="data.address_invoice.flat_number"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.postal_code"
                                :label="languageData.labels.postal_code"
                                v-model="data.address_invoice.postal_code"></v-text-field>
                          </v-col>
                          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-text-field
                                height="55px"
                                outlined
                                :placeholder="languageData.labels.city"
                                :label="languageData.labels.city"
                                v-model="data.address_invoice.city"></v-text-field>
                          </v-col>
                          <v-col
                            v-if="countries.length > 0"
                            :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12">
                            <v-select
                              v-model="data.address_invoice.country_id"
                              :items="countries"
                              :label="languageData.labels.country"
                              outlined
                              item-value="id"
                              item-text="name"
                              height="55px"
                          >
                            <template slot='selection' slot-scope='{ item }'>
                              {{ languageData.countries[item.code] }}
                            </template>
                            <template slot='item' slot-scope='{ item }'>
                              {{ languageData.countries[item.code] }}
                            </template>
                          </v-select>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                  <div class="d-flex justify-end mt-4">
                    <v-btn
                        class="button-shadow"
                        :class="layout !== 'editModal' ? 'mr-4' : null"
                        height="55px"
                        color="primary"
                        outlined
                        @click="setStep(1)">
                      {{ languageData.back }}
                    </v-btn>
                    <v-btn
                        class="button-shadow"
                        height="55px"
                        color="primary"
                        outlined
                        v-if="layout !== 'editModal'"
                        @click="setStep(3)">
                      {{ languageData.next }}
                    </v-btn>
                  </div>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-form ref="formV" v-model="validV" @hook:mounted="handleForm('formV')">
                        <p class="text-h5 mb-7">{{ languageData.section.peopleList }}</p>
                        <v-expansion-panels flat v-model="openedPanel" accordion>
                          <v-expansion-panel
                              v-for="(person, key) in data.persons.length"
                              :key="key"
                          >
                            <v-expansion-panel-header color="bgDefault" class="person-header mb-3">{{ data.persons[key].firstname }} {{ data.persons[key].lastname }}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-btn
                                  class="mt-5 mb-5"
                                  color="error"
                                   @click="showDeletePersonModal(key)">
                                {{ languageData.btnDeletePerson }}
                              </v-btn>
                              <div :class="{'d-flex': $vuetify.breakpoint.mdAndUp}">
                                <v-text-field
                                    :class="{'mr-4': $vuetify.breakpoint.mdAndUp}"
                                    height="55px"
                                    outlined
                                    :placeholder="languageData.labels.firstname"
                                    :label="languageData.labels.firstname"
                                    name="firstname"
                                    :rules="rules['persons.'+key+'.firstname']"
                                    v-model="data.persons[key].firstname"></v-text-field>
                                <v-text-field
                                    :class="{'mr-4': $vuetify.breakpoint.mdAndUp}"
                                    height="55px"
                                    outlined
                                    :placeholder="languageData.labels.lastname"
                                    :label="languageData.labels.lastname"
                                    name="lastname"
                                    :rules="rules['persons.'+key+'.lastname']"
                                    v-model="data.persons[key].lastname"></v-text-field>
                                <v-text-field
                                    height="55px"
                                    outlined
                                    :placeholder="languageData.labels.company_name"
                                    :label="languageData.labels.company_name"
                                    name="lastname"
                                    :rules="rules['persons.'+key+'.company']"
                                    v-model="data.persons[key].company"></v-text-field>
                              </div>
                              <div :class="{'d-flex': $vuetify.breakpoint.mdAndUp}">
                                <v-text-field
                                    :class="{'mr-4': $vuetify.breakpoint.mdAndUp}"
                                    height="55px"
                                    outlined
                                    :placeholder="languageData.labels.phone_number"
                                    :label="languageData.labels.phone_number"
                                    name="phone"
                                    :rules="rules['persons.'+key+'.phone']"
                                    v-model="data.persons[key].phone"></v-text-field>
                                <v-text-field
                                    :class="{'mr-4': $vuetify.breakpoint.mdAndUp}"
                                    height="55px"
                                    outlined
                                    :placeholder="languageData.labels.mobile_phone"
                                    :label="languageData.labels.mobile_phone"
                                    name="mobile"
                                    v-model="data.persons[key].mobile"></v-text-field>
                                <v-text-field
                                    height="55px"
                                    outlined
                                    :placeholder="languageData.labels.email"
                                    :label="languageData.labels.email"
                                    name="email"
                                    v-model="data.persons[key].email"></v-text-field>
                              </div>
                              <v-text-field
                                  height="55px"
                                  outlined
                                  :placeholder="languageData.labels.www"
                                  :label="languageData.labels.www"
                                  name="www"
                                  v-model="data.persons[key].www"></v-text-field>
                              <div :class="{'d-flex': $vuetify.breakpoint.mdAndUp}">
                              <v-text-field
                                  :class="{'mr-4': $vuetify.breakpoint.mdAndUp}"
                                  height="55px"
                                  outlined
                                  :placeholder="languageData.labels.street"
                                  :label="languageData.labels.street"
                                  v-model="data.persons[key].street"></v-text-field>

                              <v-text-field
                                  :class="{'mr-4': $vuetify.breakpoint.mdAndUp}"
                                  height="55px"
                                  outlined
                                  :placeholder="languageData.labels.building_number"
                                  :label="languageData.labels.building_number"
                                  v-model="data.persons[key].building_number"></v-text-field>

                                <v-text-field
                                    height="55px"
                                    outlined
                                    :placeholder="languageData.labels.flat_number"
                                    :label="languageData.labels.flat_number"
                                    v-model="data.persons[key].flat_number"></v-text-field>
                              </div>
                              <div :class="{'d-flex': $vuetify.breakpoint.mdAndUp}">
                                <v-text-field
                                    :class="{'mr-4': $vuetify.breakpoint.mdAndUp}"
                                    height="55px"
                                    outlined
                                    :placeholder="languageData.labels.postal_code"
                                    :label="languageData.labels.postal_code"
                                    v-model="data.persons[key].postal_code"></v-text-field>
                                <v-text-field
                                    height="55px"
                                    outlined
                                    :placeholder="languageData.labels.city"
                                    :label="languageData.labels.city"
                                    v-model="data.persons[key].city"></v-text-field>
                              </div>
                              <v-textarea
                                  outlined
                                  :placeholder="languageData.labels.note"
                                  :label="languageData.labels.note"
                                  v-model="data.persons[key].note"></v-textarea>
                              <v-select
                                  height="55px"
                                  outlined
                                  :label="languageData.labels.client_person_type"
                                  :rules="rules['persons.'+key+'.client_person_type']"
                                  v-model="data.persons[key].client_person_type"
                                  :items="clientPersonsTypes"
                                  item-value="value"
                                  item-text="name"
                                  :menu-props="{ maxHeight: '400' }"
                                  multiple
                                  chips
                              >
                                <template slot='selection' slot-scope='{ item }'>
                                  <v-chip>{{ languageData.clientPersonsTypes[item.value]  }}</v-chip>
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                  {{ languageData.clientPersonsTypes[item.value]  }}
                                </template>
                              </v-select>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                        <div>
                          <v-btn
                            color="primary mt-5"
                            @click="addNewPerson">
                            {{ languageData.btnAddPerson }}
                          </v-btn>
                        </div>
                        <div class="d-flex justify-end mt-4">
                          <v-btn
                              class="button-shadow"
                              :class="layout === 'edit' ? 'mr-4' : null"
                              height="55px"
                              color="primary"
                              outlined
                              @click="setStep(2)">
                            {{ languageData.back }}
                          </v-btn>
                          <v-btn
                              class="button-shadow"
                              height="55px"
                              color="primary"
                              outlined
                              v-if="layout === 'edit'"
                              @click="setStep(4)">
                            {{ languageData.next }}
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content v-if="layout === 'edit'" step="4">
                <p class="text-h5 mb-7">{{ languageData.section.notes }}</p>
                <Notes noteableType="client"></Notes>
                <div class="d-flex justify-end mt-10">
                  <v-btn
                      class="button-shadow mr-4"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(3)">
                    {{ languageData.back }}
                  </v-btn>
                  <v-btn
                      class="button-shadow"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(5)">
                    {{ languageData.next }}
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content v-if="layout === 'edit'" step="5">
                <p class="text-h5">{{ languageData.section.documents }}</p>
                <Documents v-if="$route.name === 'ClientsEdit'" documentableType="client"></Documents>
                <div class="d-flex justify-end mt-10">
                  <v-btn
                      class="button-shadow mr-4"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(4)">
                    {{ languageData.back }}
                  </v-btn>
                  <v-btn
                      class="button-shadow"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(6)">
                    {{ languageData.next }}
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content v-if="layout === 'edit'" step="6">
                <p class="text-h5 mb-7">{{ languageData.section.plannedContacts }}</p>
                <PlannedContacts contactableType="client"></PlannedContacts>
                <div class="d-flex justify-end mt-10">
                   <v-btn
                      class="button-shadow mr-4"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(5)">
                    {{ languageData.back }}
                  </v-btn>
                  <v-btn
                      class="button-shadow"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(7)">
                    {{ languageData.next }}
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content v-if="layout === 'edit'" step="7">
                <p class="text-h5 mb-7">{{ languageData.section.financialSummary }}</p>
                <FinancialSummary :financialData="dataReceive.invoicePaymentsSummary"></FinancialSummary>
                <div class="d-flex justify-end mt-10">
                  <v-btn
                      class="button-shadow"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(6)">
                    {{ languageData.back }}
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-card>
                  <v-row justify="center" style="padding: 0 24px">
                    <v-col cols="12">
                      <div class="d-flex justify-end">
                        <v-btn
                            class="button-shadow mb-5"
                            color="primary"
                            style="padding-left: 25px !important; padding-right: 25px !important"
                            height="55px"
                            :loading="(dataSaveIsFetching && dataSavePersonIsFetching) || (dataUpdateIsFetching && dataUpdatePersonIsFetching) "
                            @click="saveClientData">{{ languageData.btnSubmit }}</v-btn>
                      </div>
                    </v-col>
                  </v-row>
              </v-card>
              
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <ClientsRelations v-if="(layout !== 'projectForm' || layout !== 'offerForm') && layout === 'edit'"></ClientsRelations>
    <ModalInfo v-if="layout !== 'projectForm'" :typeInfo="typeInfoClientSave || typeInfoPersonSave" :headModal="headInfoClientSave || headInfoPersonSave" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="false" @clicked="hideModal" :show-modal="isClientSave || isPersonSave" :text-modal="textInfoClientSave || textInfoPersonSave"></ModalInfo>
    <ModalInfo :typeInfo="typeInfoClientUpdate || typeInfoPersonUpdate" :headModal="headInfoClientUpdate || headInfoPersonUpdate" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="false" @clicked="hideModal" :show-modal="isClientUpdate || isPersonUpdate" :text-modal="textInfoClientUpdate || textInfoPersonUpdate"></ModalInfo>
    <ModalInfo @doOperation="deletePerson(modalDeleteData.index, data.persons[modalDeleteData.index].id)" :isLoadingBtn="false" :idData="modalDeleteData.id" :typeInfo="languageData.modalDelete.typeInfo" :headModal="languageData.modalDeleteClientPerson.head" :btnDisAgreeText="languageData.modalDeleteClientPerson.btnDisAgreeText" :btnAgreeText="languageData.modalDeleteClientPerson.btnAgreeText" :visDisAgreeBtn="true" @clicked="hideModalDelete" :show-modal="isShowDeleteModal" :text-modal="languageData.modalDeleteClientPerson.textInfo + modalDeleteData.name"></ModalInfo>
  </v-container>
</template>
-

<script type="text/javascript">
  import clientTypes from "../../enums/ClientTypeEnum";
  import { mapActions, mapState } from "vuex";
  import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
  import eventBus from "../../../../event-bus/eventBus";
  import clientPersonTypes from "../../enums/ClientPersonTypeEnum";
  import handleFormError from "../../../../helpers/handleFormError";
  import hexColorGenerator from "../../../../helpers/hexColorGenerator";
  import ClientsRelations from "../ClientsRelations/ClientsRelations";
  import Documents from "../../../Documents/components/Documents/Documents";
  import Notes from "../../../Notes/components/Notes";
  import PlannedContacts from "../../../PlannedContacts/components/PlannedContacts";
  import BackButton from "../../../../components/Global/BackButton";
  import FinancialSummary from "../../../Invoices/components/FinancialSummary/FinancialSummary.vue"

  export default {
    name: "ClientsForm",
    props: {
      layout: String,
      clientId: [Number, Object],
    },
    components: {BackButton, ModalInfo, ClientsRelations, Documents, Notes, PlannedContacts, FinancialSummary},
    watch: {
      'data.persons': {
        deep: true,
        handler: function(newValue, oldValue) {
          if (oldValue.length !== 0) {
            this.handleEventListenerOnInputs()
          }
        }
      },
      validS: function() {
        this.isValidS();
      },
      validT: function() {
        this.isValidT();
      },
      validU: function() {
        this.isValidU();
      },
      validV: function() {
        this.isValidV();
      },
    },
    mounted() {
      if(this.layout === "edit") {
        const language = this.getCurrentLanguage;
        this.getHeadersInvoiceItems({ creds: { language } });
        this.getClient();
      } else if (this.layout === "editModal") {
        this.data = this.clientId;
      }
      eventBus.$on("showProjectForm", () => {
        this.$refs.formS.reset();
        this.$refs.formT.reset();
        if(this.$refs.formU !== undefined) {
          this.$refs.formU.reset();
        }
        this.$refs.formV.reset();
        this.data.persons = [];
        this.setStep(1);
      });
      this.getCountriesRequest();
      eventBus.$on("saveClientSuccess", (clientId) => {
        const url = window.location.href;
        if ((url.includes('projects/add') || url.includes('projects/edit') || url.includes('offers/add') || url.includes('offers/edit')) && !this.isDataChanged) {
          this.updateDataInFormIsChanged(true);
        }
        const persons = this.data.persons;
        const client_id = clientId;
        const layout = this.layout;
        const data = this.data;
        this.resetInfo();
        this.saveClientPerson({ creds: { persons, client_id, layout, data} });
      });
      eventBus.$on("updateClientSuccess", () => {
          let url = new URL(window.location.href);
          const persons = this.data.persons;
          const client_id = url.searchParams.get("id");
          const deletePersons = this.deletePersons;
          this.resetInfoUpdate();
          if (this.layout !== "editModal" && this.layout !== 'projectForm' && this.layout !== 'offerForm') {
            this.updateClientPerson({ creds: { persons, client_id, deletePersons } });
          }
          if (this.layout === 'editModal') {
            eventBus.$emit('closeClientFormModalEvent');
          }
      });
      eventBus.$on("deleteLastClient", (lastId) => {
        this.deleteClientRequest(lastId);
      });
      eventBus.$on("saveClientFailure", (errorsData, isClientPerson) => {
        if(this.layout !== "edit" && isClientPerson) {
          this.getLastClientId();
        }
        this.rules = handleFormError(errorsData);

        this.validS = this.$refs.formS.validate();
        this.validT = this.$refs.formT.validate();
        this.isValidS();
        this.isValidT();
        if(!this.data.invoice_is) {
          this.$refs.formU.validate();
          this.isValidU();
        }
        this.$refs.formV.validate();
        this.isValidV();
      });
      eventBus.$on("getClientSuccess", () => {
        if(this.dataReceive !== null) {
          this.data = this.dataReceive;
        }
      });
      eventBus.$on("savePlannedContactSuccess", (dataReceive) => {
        this.getSnackbarSuccess(dataReceive.title, dataReceive.message);
        this.updateVisiblePlannedContactFormModal(false);
      });
      eventBus.$on("changeLanguage", (value) => {
        this.getCountriesRequest();
      });
      eventBus.$on('updateClientPersonsSuccess', () => {
        this.getClient();
      });
      this.data.customerNumber = this.generateRandomCustomerNumber();
    },
    data() {
      return {
        e1: 1,
        data: {
          invoice_is: true,
          address: {},
          address_invoice: {
          },
          enabled: true,
          persons: []
        },
        openedPanel: 0,
        deletePersons: [],
        clientPersonsTypes: clientPersonTypes,
        rules: {
          address: {}
        },
        validC: "",
        validS: false,
        validT: false,
        validU: false,
        validV: false,
        items: clientTypes,
        modalPersonSave: {},
        modalPersonFailure: {},
        isModalPersonFailure: false,
        snackbar: {
          color: null,
          icon: null,
          mode: null,
          position: null,
          text: null,
          corner: null,
          timeout: 7500,
          title: null,
          visible: false
        },
        isShowDeleteModal: false,
        modalDeleteData: {},
        isCustomerNumberAutoGenerated: true,
      }  
    },
    computed: {
      ...mapState("updateClientPerson", {
        typeInfoPersonUpdate: state => state.typeInfoPersonUpdate,
        headInfoPersonUpdate: state => state.headInfoPersonUpdate,
        textInfoPersonUpdate: state => state.textInfoPersonUpdate,
        isPersonUpdate: state => state.isPersonUpdate,
        dataUpdatePersonIsFetching: state => state.dataUpdatePersonIsFetching
      }),
      ...mapState("saveClientPerson", {
        typeInfoPersonSave: state => state.typeInfoPersonSave,
        headInfoPersonSave: state => state.headInfoPersonSave,
        textInfoPersonSave: state => state.textInfoPersonSave,
        isPersonSave: state => state.isPersonSave,
        dataSavePersonIsFetching: state => state.dataSavePersonIsFetching,
      }),
      ...mapState("updateClient", {
        isClientUpdate: state => state.isClientUpdate,
        dataUpdateIsFetching: state => state.dataUpdateIsFetching,
        typeInfoClientUpdate: state => state.typeInfoClientUpdate,
        headInfoClientUpdate: state => state.headInfoClientUpdate,
        textInfoClientUpdate: state => state.textInfoClientUpdate
      }),
      ...mapState("saveClient", {
        dataSaveIsFetching: state => state.dataSaveIsFetching,
        typeInfoClientSave: state => state.typeInfoClientSave,
        headInfoClientSave: state => state.headInfoClientSave,
        isClientSave: state => state.isClientSave,
        textInfoClientSave: state => state.textInfoClientSave,
      }),
      ...mapState("getClient", {
        dataReceive: state => state.dataReceive,
      }),
      ...mapState("getProject", {
        project: state => state.dataReceive
      }),
       ...mapState("preventDataLost", {
        isDataChanged: state => state.isDataChanged,
      }),
      ...mapState("getCountries", {
        countries: state => state.countries,
      })
    },
    methods: {
      ...mapActions("saveClient", ["storeClient", "updateVisibleModalClient", "setStep", "resetInfo"]),
      ...mapActions("getClient", ["getClient", "getLastClientId"]),
      ...mapActions("updateClient", ["updateClient", "updateVisibleModalUpdate", "resetInfoUpdate"]),
      ...mapActions("saveClientPerson", ["saveClientPerson", "updateVisibleModalPerson"]),
      ...mapActions("updateClientPerson", ["updateClientPerson", "updateVisibleModalUpdatePerson"]),
      ...mapActions("deleteClient", ["deleteClientRequest"]),
      ...mapActions("updateVisiblePlannedContactFormModal", ["updateVisiblePlannedContactFormModal"]),
      ...mapActions("getHeadersInvoiceItems", ["getHeadersInvoiceItems"]),
      ...mapActions("preventDataLost", ["updateDataInFormIsChanged"]),
      ...mapActions("getCountries", ["getCountriesRequest"]),

      handleEventListenerOnInputs() {
        if (!this.isDataChanged && !this.isClientUpdate && !this.isClientSave) {
          this.updateDataInFormIsChanged(true);
        }
      },
      handleForm(refForm) {
        const inputs = this.$refs[refForm].inputs;
        inputs.forEach(el => {
          if (el.$refs.input) {
            el.$refs.input.addEventListener('input', this.handleEventListenerOnInputs)
          }
        })
      },
      removeEventListeners(refForm) {
        const inputs = this.$refs[refForm].inputs;
        inputs.forEach(el => {
          if (el.$refs.input) {
            el.$refs.input.removeEventListener('input', this.handleEventListenerOnInputs)
          }
        })
      },

      addNewPerson: function() {
        this.data.persons.push({
          "firstname": "",
          "lastname": "",
          "phone": "",
          "email": "",
          "clientPersonType": ""
        });
        this.openedPanel = this.data.persons.length - 1;
      },
      setStep: function(step) {
        this.e1 = step;
        if (this.$refs.lastStep) this.$vuetify.goTo(this.$refs.lastStep);
      },
      saveClientData: function() {
        this.$refs.formS.resetValidation();
        this.$refs.formT.resetValidation();
        this.rules = [];
        this.data.language = localStorage.getItem("language");
        this.updateDataInFormIsChanged(false);
        if(this.layout === "edit" || this.layout === "editModal") {
          this.updateClient({ creds: this.data });
        } else {
          this.data.hexColor = hexColorGenerator();
          this.storeClient({ creds: this.data });
        }
      },
      isValidS: function() {
        if(this.validS === false) {
          this.setStep(1);
        }
      },
      isValidT: function() {
        if(this.validT === false && this.validS !== false) {
          this.setStep(2);
        }
      },
      isValidU: function() {
        if(this.validU === false && this.validS !== false && this.validT !== false) {
          this.setStep(2);
        }
      },
      isValidV: function() {
        if(this.validV === false && this.validS !== false && this.validT !== false && this.validU !== false) {
          this.setStep(3);
        }
      },
      hideModal: function() {
        if(this.layout === "edit" || this.layout === "editModal") {
          this.updateVisibleModalUpdate(false);
          this.updateVisibleModalUpdatePerson(false);
        } else {
          this.updateVisibleModalClient(false);
          this.updateVisibleModalPerson(false);
        }
      },
      showDeletePersonModal: function(key) {
        var person = this.data.persons[key];
        this.modalDeleteData = {};
        this.modalDeleteData.name = ' ' + person.firstname + ' ' + person.lastname;
        this.modalDeleteData.id = person.id;
        this.modalDeleteData.index = key;
        this.modalDeleteData.languageData = this.languageData.modalDeleteClientPerson;
        this.isShowDeleteModal = true;
      },
      hideModalDelete: function() {
        this.isShowDeleteModal = false;
      },
      deletePerson: function(key, personId) {
        if(typeof(personId) !== "undefined") {
          this.deletePersons.push(personId);
        }
        this.data.persons.splice(key, 1);
        this.isShowDeleteModal = false;
      },
      getSnackbarSuccess: function(title, message) {
        this.snackbar = {
          color: "success",
          icon: "check_circle",
          mode: "multi-line",
          position: "top",
          timeout: 7500,
          corner: 'right',
          title: title,
          text: message,
          visible: true
        };
      },
      handleCustomerNumberGeneration() {
        if (this.isCustomerNumberAutoGenerated) {
          this.data.customerNumber = this.generateRandomCustomerNumber();
        } else {
          this.data.customerNumber = '';
        }
      },
      generateRandomCustomerNumber() {
        return Math.floor(100000 + Math.random() * 900000).toString();
      }
    },
    beforeDestroy() {
      eventBus.$off('getClientSuccess');
      eventBus.$off('saveClientSuccess');
      eventBus.$off('saveClientFailure');
      eventBus.$off('updateClientSuccess');
      this.removeEventListeners('formS');
      this.removeEventListeners('formT');
      this.removeEventListeners('formV');
    }
  }
</script>

<style src="./ClientsForm.scss" lang="scss"></style>